
// this file is automatically generated by git.version.ts script
export const versions = {
  version: '25.45.15',
  revision: 'bb0df5984',
  branch: 'master'
};